import { SyncTableConfig } from "./types";

export const SMART_CARDS_TABLE_CONFIG: SyncTableConfig = {
  shapeKey: "smart_cards",
  table: "smart_cards",
  columns: [
    "id",
    "associated_space_account_id",
    "smart_context_id",
    "smart_view_id",
    "sort_key",
    "added_by_space_account_id",
    "derived_kind",
    "derived_internal_label",
    "value_json",
    "refreshed_at",
    "created_at",
    "updated_at",
  ],
  primaryKey: ["id"],
  parser: { timestamptz: (d: string) => new Date(d).toISOString() },
  enabled: false,
};
